(function () {
  function getParam(key) {
    return new URLSearchParams(window.location.search).get(key) || '';
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function show(id) {
    var el = document.getElementById(id);
    if (el) el.style.display = '';
  }

  function hide(id) {
    var el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  function makePlantCard(p) {
    var card = document.createElement('div');
    card.className = 'bp-plant-card';

    var badge = document.createElement('div');
    badge.className = 'bp-plant-qty';
    badge.textContent = p.qty + '×';

    var info = document.createElement('div');

    var name = document.createElement('div');
    name.className = 'bp-plant-name';
    name.textContent = p.name;

    var total = document.createElement('div');
    total.className = 'bp-plant-total';
    total.textContent = p.qty + ' plant' + (p.qty > 1 ? 'en' : '');

    info.appendChild(name);
    info.appendChild(total);
    card.appendChild(badge);
    card.appendChild(info);
    return card;
  }

  function renderPlants(plants) {
    var grid = document.getElementById('bp-plants-grid');
    if (!grid) return;
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    plants.forEach(function (p) {
      grid.appendChild(makePlantCard(p));
    });
  }

  function renderBorderplan(imageUrl, pdfUrl, title) {
    var section = document.getElementById('bp-plan-section');
    if (!section) return;
    if (!imageUrl && !pdfUrl) { section.style.display = 'none'; return; }

    var thumb = document.getElementById('bp-plan-thumb');
    var preview = document.getElementById('bp-plan-preview');
    var dlBtn = document.getElementById('bp-plan-download');

    if (thumb && imageUrl) {
      thumb.src = imageUrl;
      thumb.style.display = '';
    }

    if (dlBtn && pdfUrl) {
      dlBtn.href = pdfUrl;
      dlBtn.style.display = 'inline-flex';
    }

    if (preview && pdfUrl) {
      preview.addEventListener('click', function() { openPdfModal(pdfUrl, title); });
      preview.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') openPdfModal(pdfUrl, title);
      });
    } else if (preview) {
      var overlay = preview.querySelector('.bp-plan-overlay');
      if (overlay) overlay.style.display = 'none';
    }

    section.style.display = '';
  }

  function openPdfModal(pdfUrl, title) {
    var modal   = document.getElementById('bp-pdf-modal');
    var iframe  = document.getElementById('bp-modal-iframe');
    var dlLink  = document.getElementById('bp-modal-download');
    var titleEl = document.getElementById('bp-modal-title');
    var close   = document.getElementById('bp-modal-close');
    var backdrop = document.getElementById('bp-modal-backdrop');
    if (!modal || !iframe) return;

    iframe.src = pdfUrl;
    if (dlLink) dlLink.href = pdfUrl;
    if (titleEl) titleEl.textContent = title || 'Jouw borderplan';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    function closeModal() {
      modal.style.display = 'none';
      iframe.src = '';
      document.body.style.overflow = '';
    }
    if (close) close.onclick = closeModal;
    if (backdrop) backdrop.onclick = closeModal;
    modal.onkeydown = function(e) { if (e.key === 'Escape') closeModal(); };
    modal.focus();
  }

  function init() {
    var sku  = getParam('sku');
    var naam = getParam('naam');

    var data = window.BORDERPLAN_DATA;
    if (!data) return;

    var pakket = data[sku];

    if (!pakket) {
      hide('bp-main');
      show('bp-not-found');
      return;
    }

    var displayNaam = naam || 'tuinier';
    setText('bp-naam', displayNaam);
    setText('bp-pakket-label', pakket.pakket);
    setText('bp-pakket-size', pakket.size);
    setText('bp-pakket-title', pakket.pakket + ' · ' + pakket.size);

    renderPlants(pakket.plants);
    renderBorderplan(pakket.image_url, pakket.pdf_url, pakket.pakket + ' · ' + pakket.size);

    show('bp-main');
    hide('bp-loading');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
